<template>
  <v-form ref="userForm" v-model="valid" :lazy-validation="lazy">
    <v-row dense class="mb-4">
      <v-col cols="12" md="4">
        <v-text-field outlined dense label="Name" v-model="record.name" :rules="inputRules"></v-text-field>
      </v-col>

      <v-col cols="12" md="4">
        <v-text-field outlined dense label="Email" v-model="record.email" :rules="inputRules"></v-text-field>
      </v-col>

      <v-col cols="12" md="4">
        <v-text-field outlined dense label="Phone No" v-model="record.phoneNumber" :rules="inputRules"></v-text-field>
      </v-col>

      <v-col cols="12" md="4">
        <v-text-field outlined dense label="Identification No" v-model="record.idNo"></v-text-field>
      </v-col>

      <v-col cols="12" md="4">
        <v-text-field outlined dense label="User Name" v-model="record.userName" :rules="inputRules"></v-text-field>
      </v-col>

      <v-col cols="12" md="4" v-show="docCreate == true">
        <v-text-field outlined dense label="Password ( for back office)" v-model="record.password"
          :rules="computedRules" prepend-icon="mdi-lock" :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
          :type="showPassword ? 'text' : 'password'" @click:append="showPassword = !showPassword"></v-text-field>
      </v-col>

      <v-col cols="12" md="4" v-show="docCreate == true">
        <v-text-field outlined dense label="User Pin (for offline)" v-model="record.userPin" :rules="computedRules"
          prepend-icon="mdi-lock" :append-icon="showPin ? 'mdi-eye' : 'mdi-eye-off'"
          :type="showPin ? 'text' : 'password'" @click:append="showPin = !showPin"></v-text-field>
      </v-col>

      <v-col cols="12" md="4">
        <v-text-field type="number" outlined dense label="Monthly Sales Target"
          v-model="monthlySalesTarget"></v-text-field>
      </v-col>

      <v-col cols="12" md="4">
        <v-autocomplete autocomplete="off" name="userStore" hide-details dense outlined v-model="record.storeId"
          :items="stores" label="Store / Shop" item-text="Name" item-value="id" :rules="inputRules"></v-autocomplete>
      </v-col>

      <v-col cols="12" md="4">
        <v-autocomplete autocomplete="off" name="userGroup" hide-details dense outlined v-model="record.role"
          :items="userGroups" label="Select User Group" item-text="name" item-value="id"></v-autocomplete>
      </v-col>

      <v-col cols="12" md="4">
        <v-autocomplete autocomplete="off" name="storeSection" hide-details dense outlined
          v-model="record.storeSectionId" :items="storeSections" label="Store Section / Shop Section" item-text="Name"
          item-value="id" clearable></v-autocomplete>
      </v-col>

      <v-col cols="12" md="4">
        <v-text-field type="number" outlined dense label="Percent" v-model="record.queryPercent"></v-text-field>
      </v-col>

      <v-col cols="12" md="8">
        <v-btn color="primary" @click="shopDialog = true" text>
          <v-icon left>mdi-plus</v-icon>
          <span style="font-weight: bold"> Assign Shops / Stores For Backoffice Access</span>
        </v-btn>
      </v-col>

      <v-col cols="12" v-if="selectedShops.length > 0">
        <v-card outlined class="mt-2">
          <v-card-title class="primary white--text py-2">
            <v-icon left dark>mdi-store-check</v-icon>
            <span class="text-subtitle-1">Assigned Shops ({{ selectedShops.length }})</span>
          </v-card-title>
          <v-divider></v-divider>
          <v-list dense class="py-0">
            <v-list-item v-for="(shop, index) in selectedShops" :key="shop.id" class="py-1">
              <v-list-item-avatar color="primary" size="32" class="mr-3">
                <span class="white--text text-caption">{{ index + 1 }}</span>
              </v-list-item-avatar>
              <v-list-item-content class="flex-grow-0" style="flex-basis: 33.33%; max-width: 33.33%;">
                <v-list-item-title class="font-weight-medium">
                  {{ shop.Name }}
                </v-list-item-title>
              </v-list-item-content>
              <div style="flex-basis: 33.33%; max-width: 33.33%;">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn icon x-small color="error" @click="removeShop(shop.id)" v-bind="attrs" v-on="on">
                      <v-icon>mdi-close</v-icon>
                    </v-btn>
                  </template>
                  <span>Remove shop</span>
                </v-tooltip>
              </div>
              <v-divider v-if="index < selectedShops.length - 1" class="my-0"></v-divider>
            </v-list-item>
          </v-list>
        </v-card>
      </v-col>



    </v-row>

    <v-divider></v-divider>

    <v-row class="mt-6" dense>
      <v-col cols="12" md="12" style="margin-top: -25px" class="mb-4">
        <span class="custom-accent style-16">Sale Related Controls </span>
      </v-col>

      <v-col cols="12" md="4">
        <v-checkbox color="accent" style="margin-top: -25px" v-model="CanPostStartingFloat"
          :label="`Can post starting float`"></v-checkbox>
      </v-col>

      <v-col cols="12" md="4">
        <v-checkbox color="accent" style="margin-top: -25px" v-model="CanCloseAccounts"
          :label="`Can close accounts`"></v-checkbox>
      </v-col>

      <v-col cols="12" md="4">
        <v-checkbox color="accent" style="margin-top: -25px" v-model="CanSellOnCredit"
          :label="`Can sell on credit`"></v-checkbox>
      </v-col>


      <v-col cols="12" md="4">
        <v-checkbox color="accent" style="margin-top: -25px" v-model="CanEditSale"
          :label="`Can edit sales`"></v-checkbox>
      </v-col>

      <v-col cols="12" md="4">
        <v-checkbox color="accent" style="margin-top: -25px" v-model="CanReprintReceipt"
          :label="`Can reprint receipt`"></v-checkbox>
      </v-col>


      <v-col cols="12" md="4">
        <v-checkbox color="accent" style="margin-top: -25px" v-model="CanReturnSoldItems"
          :label="`Can do sales returns`"></v-checkbox>
      </v-col>

      <v-col cols="12" md="4">
        <v-checkbox color="accent" style="margin-top: -20px" v-model="HideDebtorsTotal"
          :label="`Should not see debtors total`"></v-checkbox>
      </v-col>

      <v-col cols="12" md="4">
        <v-checkbox color="accent" style="margin-top: -20px" v-model="CanReceiveDebtorPayments"
          :label="`Can Receive Debtors Payments`"></v-checkbox>
      </v-col>

      <v-col cols="12" md="4">
        <v-checkbox color="accent" style="margin-top: -25px" v-model="CanPrintTransferDelivery"
          :label="`Can print transfer delivery`"></v-checkbox>
      </v-col>

      <v-col cols="12" md="4">
        <v-checkbox color="accent" style="margin-top: -25px" v-model="CanSeeSalesTotal"
          :label="`Can See Sales Total`"></v-checkbox>
      </v-col>

      <v-col cols="12" md="4">
        <v-checkbox color="accent" style="margin-top: -25px" v-model="HideTotalSales"
          :label="`Hide Total Sales`"></v-checkbox>
      </v-col>

      <v-col cols="12" md="4">
        <v-checkbox color="accent" style="margin-top: -25px" v-model="HideProfitReports"
          :label="`Hide Profit Reports`"></v-checkbox>
      </v-col>

    </v-row>

    <!-- end of sales controls -->

    <v-divider></v-divider>

    <v-row class="mt-6" dense>

      <v-col cols="12" md="12" style="margin-top: -25px" class="mb-4">
        <span class="custom-accent style-16">Purchases Related Controls </span>
      </v-col>

      <v-col cols="12" md="4">
        <v-checkbox color="accent" style="margin-top: -25px" v-model="CanPurchaseGoods"
          :label="`Can record purchases`"></v-checkbox>
      </v-col>

      <v-col cols="12" md="4">
        <v-checkbox color="accent" style="margin-top: -25px" v-model="CanEditPurchase"
          :label="`Can Edit Purchases`"></v-checkbox>
      </v-col>

      <v-col cols="12" md="4">
        <v-checkbox color="accent" style="margin-top: -25px" v-model="CanDoPurchaseReturns"
          :label="`Can do purchase returns`"></v-checkbox>
      </v-col>

      <v-col cols="12" md="4">
        <v-checkbox color="accent" style="margin-top: -25px" v-model="CanUpdateBuyingPrice"
          :label="`Can update buying price`"></v-checkbox>
      </v-col>

      <v-col cols="12" md="4">
        <v-checkbox color="accent" style="margin-top: -20px" v-model="CanSeeStockBalance"
          :label="`Can See Stock Balance`"></v-checkbox>
      </v-col>

      <v-col cols="12" md="4">
        <v-checkbox color="accent" style="margin-top: -20px" v-model="CanPaySuppliers"
          :label="`Can Pay Suppliers`"></v-checkbox>
      </v-col>

      <v-col cols="12" md="4">
        <v-checkbox color="accent" style="margin-top: -20px" v-model="CanAdjustStock"
          :label="`Can Adjust Stock`"></v-checkbox>
      </v-col>
    </v-row>

    <v-divider></v-divider>

    <v-row class="mt-6" dense>
      <v-col cols="12" md="12" style="margin-top: -25px" class="mb-4">
        <span class="custom-accent style-16">Products / General Controls </span>
      </v-col>

      <v-col cols="12" md="4">
        <v-checkbox color="accent" style="margin-top: -20px" v-model="CanBackDate"
          :label="`Can Back Date Records`"></v-checkbox>
      </v-col>

      <v-col cols="12" md="4">
        <v-checkbox color="accent" style="margin-top: -20px" v-model="CanEditBpTransfer"
          :label="`Can edit buying price upon stock transfer`"></v-checkbox>
      </v-col>

      <v-col cols="12" md="4">
        <v-checkbox color="accent" style="margin-top: -20px" v-model="CanUpdateProduct"
          :label="`Can Update Product Details`"></v-checkbox>
      </v-col>

      <v-col cols="12" md="4">
        <v-checkbox color="accent" style="margin-top: -20px" v-model="CanDeleteProduct"
          :label="`Can Delete Product`"></v-checkbox>
      </v-col>


      <v-col cols="12" md="4">
        <v-checkbox color="accent" style="margin-top: -25px" v-model="CanPostExpenses"
          :label="`Can post expenses`"></v-checkbox>
      </v-col>

      <v-col cols="12" md="4">
        <v-checkbox color="accent" style="margin-top: -20px" v-model="CanEditQtyMobile"
          :label="`Can Edit Qty On mobile App`"></v-checkbox>
      </v-col>

      <v-col cols="12" md="4">
        <v-checkbox color="accent" style="margin-top: -20px" v-model="CanEditPriceMobile"
          :label="`Can Edit Price On mobile App`"></v-checkbox>
      </v-col>


    </v-row>

    <v-divider></v-divider>

    <v-row>
      <v-col cols="12" md="4">
        <v-checkbox color="accent" v-model="ShowVatSalesOnly" :label="`Show VAT Sales Only`"></v-checkbox>
      </v-col>

    </v-row>

    <v-row class="mt-2">
      <v-col cols="12">
        <v-btn v-if="docCreate == true" color="primary" @click="sendData" :loading="$store.state.btnLoader">
          <v-icon left>mdi-content-save</v-icon>Create User
        </v-btn>

        <v-btn v-else color="primary" @click="sendData" :loading="$store.state.btnLoader">
          <v-icon left>mdi-content-save</v-icon>Update
        </v-btn>
      </v-col>
    </v-row>

    <snackbar ref="snackbar"></snackbar>

    <!-- Shop Selection Modal -->
    <v-dialog v-model="shopDialog" max-width="600px">
      <v-card>
        <v-card-title class="primary white--text">
          <span>Select Shops</span>
          <v-spacer></v-spacer>
          <v-btn icon dark @click="shopDialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text class="pt-4">
          <v-text-field v-model="shopSearch" label="Search shops" prepend-inner-icon="mdi-magnify" outlined dense
            clearable></v-text-field>
          <v-list dense max-height="400" style="overflow-y: auto">
            <v-list-item-group multiple v-model="tempSelectedShopIds">
              <v-list-item v-for="shop in filteredShops" :key="shop.id" :value="shop.id">
                <template v-slot:default="{ active }">
                  <v-list-item-action>
                    <v-checkbox :input-value="active" color="primary"></v-checkbox>
                  </v-list-item-action>
                  <v-list-item-content>
                    <v-list-item-title>{{ shop.Name }}</v-list-item-title>
                  </v-list-item-content>
                </template>
              </v-list-item>
            </v-list-item-group>
          </v-list>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="shopDialog = false">Cancel</v-btn>
          <v-btn color="primary" @click="saveShopSelection">
            Add To List
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-form>
</template>


<script>
export default {
  computed: {
    computedRules() {
      return this.docCreate ? this.inputRules : [];
    },
    filteredShops() {
      if (!this.shopSearch) {
        return this.stores;
      }
      return this.stores.filter(shop =>
        shop.Name.toLowerCase().includes(this.shopSearch.toLowerCase())
      );
    }
  },
  props: {
    initial: {
      type: Object,
      required: true
    },
    docCreate: {
      type: Boolean
    }
  },
  data: () => ({
    record: { shopsAssigned: [] },
    showPassword: false,
    showPin: false,
    userGroups: [],
    valid: false,
    lazy: false,
    inputRules: [v => !!v || "Required"],
    monthlySalesTarget: null,
    stores: [],
    storeSections: [],
    storesArray: [],
    shopDialog: false,
    shopSearch: '',
    tempSelectedShopIds: [],
    selectedShops: [],
    date: new Date().toISOString().substr(0, 10),
    roles: [
      { name: "Subscriber", role: 3 },
      { name: "Admin", role: 2 },
      { name: "Cashier", role: 1 }
    ],
    CanSellOnCredit: false,
    CanPostStartingFloat: false,
    CanCloseAccounts: false,
    CanEditSale: false,
    CanPostExpenses: false,
    CanReprintReceipt: false,
    CanPurchaseGoods: false,
    CanBackDatePurchases: false,
    CanReturnSoldItems: false,
    CanUpdateBuyingPrice: false,
    CanBackDate: false,
    HideDebtorsTotal: false,
    HideProfitReports: false,
    CanEditQtyMobile: false,
    CanEditPriceMobile: false,
    CanUpdateProduct: false,
    CanDeleteProduct: false,
    CanDoPurchaseReturns: false,
    CanReceiveDebtorPayments: false,
    CanPaySuppliers: false,
    CanAdjustStock: false,
    CanEditPurchase: false,
    CanEditBpTransfer: false,
    ShowVatSalesOnly: false,
    CanPrintTransferDelivery: false,
  }),
  watch: {
    initial: {
      handler: "init",
      immediate: true
    }
  },
  methods: {
    init(val) {
      if (val) {
        delete val.userPin;
        delete val.password;
        this.record = { ...val };

        // Convert single shopsAssigned to array for multiple selection
        if (this.record.shopsAssigned && !Array.isArray(this.record.shopsAssigned)) {
          this.record.shopsAssigned = [this.record.shopsAssigned];
        }

        // Initialize selected shops from record
        this.updateSelectedShops();

        this.CanSellOnCredit = val.CanSellOnCredit == "Y" ? true : false;
        this.CanPostStartingFloat =
          val.CanPostStartingFloat == "Y" ? true : false;
        this.CanCloseAccounts = val.CanCloseAccounts == "Y" ? true : false;
        this.CanEditSale = val.CanEditSale == "Y" ? true : false;
        this.CanPostExpenses = val.CanPostExpenses == "Y" ? true : false;
        this.CanReprintReceipt = val.CanReprintReceipt == "Y" ? true : false;
        this.CanPurchaseGoods = val.CanPurchaseGoods == "Y" ? true : false;
        this.CanReturnSoldItems = val.CanReturnSoldItems == "Y" ? true : false;
        this.CanDoPurchaseReturns = val.CanDoPurchaseReturns == "Y" ? true : false;
        this.CanUpdateBuyingPrice = val.CanUpdateBuyingPrice == "Y" ? true : false;
        this.CanBackDate = val.CanBackDate == "Y" ? true : false;
        this.HideDebtorsTotal = val.HideDebtorsTotal == "Y" ? true : false;
        this.CanEditPriceMobile = val.CanEditPriceMobile == "Y" ? true : false;
        this.CanEditQtyMobile = val.CanEditQtyMobile == "Y" ? true : false;
        this.CanUpdateProduct = val.CanUpdateProduct == "Y" ? true : false;
        this.CanDeleteProduct = val.CanDeleteProduct == "Y" ? true : false;
        this.CanSeeStockBalance = val.CanSeeStockBalance == "Y" ? true : false;

        this.CanReceiveDebtorPayments = val.CanReceiveDebtorPayments == "Y" ? true : false;
        this.CanPaySuppliers = val.CanPaySuppliers == "Y" ? true : false;
        this.CanAdjustStock = val.CanAdjustStock == "Y" ? true : false;
        this.CanEditPurchase = val.CanEditPurchase == "Y" ? true : false;

        this.CanEditBpTransfer = val.CanEditBpTransfer == "Y" ? true : false;
        this.ShowVatSalesOnly = val.ShowVatSalesOnly == "Y" ? true : false;
        this.CanPrintTransferDelivery = val.CanPrintTransferDelivery == "Y" ? true : false;
        this.CanSeeSalesTotal = val.CanSeeSalesTotal == "Y" ? true : false;
        this.HideTotalSales = val.HideTotalSales == "Y" ? true : false;
        this.HideProfitReports = val.HideProfitReports == "Y" ? true : false;
      }
    },
    setDate(date) {
      this.record.date = date;
    },
    sendData() {
      if (!this.$refs.userForm.validate()) {
        this.$refs.snackbar.show("Please fill all the fields", "red");
        return;
      }

      var monthlySalesTarget = parseFloat(this.monthlySalesTarget) ?? 0.0;
      this.record.monthlySalesTarget = monthlySalesTarget;
      this.record.CanSellOnCredit = this.CanSellOnCredit ? "Y" : "N";
      this.record.CanPostStartingFloat = this.CanPostStartingFloat ? "Y" : "N";
      this.record.CanCloseAccounts = this.CanCloseAccounts ? "Y" : "N";
      this.record.CanEditSale = this.CanEditSale ? "Y" : "N";
      this.record.CanPostExpenses = this.CanPostExpenses ? "Y" : "N";
      this.record.CanReprintReceipt = this.CanReprintReceipt ? "Y" : "N";
      this.record.CanPurchaseGoods = this.CanPurchaseGoods ? "Y" : "N";
      this.record.CanReturnSoldItems = this.CanReturnSoldItems ? "Y" : "N";
      this.CanDoPurchaseReturns = this.CanDoPurchaseReturns ? "Y" : "N"
      this.record.CanUpdateBuyingPrice = this.CanUpdateBuyingPrice ? "Y" : "N";
      this.record.CanBackDate = this.CanBackDate ? "Y" : "N";
      this.record.HideDebtorsTotal = this.HideDebtorsTotal ? "Y" : "N";
      this.record.CanEditPriceMobile = this.CanEditPriceMobile ? "Y" : "N";
      this.record.CanEditQtyMobile = this.CanEditQtyMobile ? "Y" : "N";
      this.record.CanUpdateProduct = this.CanUpdateProduct ? "Y" : "N";
      this.record.CanDeleteProduct = this.CanDeleteProduct ? "Y" : "N";
      this.record.CanSeeStockBalance = this.CanSeeStockBalance ? "Y" : "N";
      this.record.CanBackDatePurchases = this.CanBackDatePurchases ? "Y" : "N";
      this.record.CanReceiveDebtorPayments = this.CanReceiveDebtorPayments ? "Y" : "N";
      this.record.CanPaySuppliers = this.CanPaySuppliers ? "Y" : "N";
      this.record.CanAdjustStock = this.CanAdjustStock ? "Y" : "N";
      this.record.CanEditPurchase = this.CanEditPurchase ? "Y" : "N";
      this.record.CanEditBpTransfer = this.CanEditBpTransfer ? "Y" : "N";
      this.record.CanPrintTransferDelivery = this.CanPrintTransferDelivery ? "Y" : "N";
      this.record.ShowVatSalesOnly = this.ShowVatSalesOnly ? "Y" : "N";
      this.record.CanSeeSalesTotal = this.CanSeeSalesTotal ? "Y" : "N";
      this.record.HideTotalSales = this.HideTotalSales ? "Y" : "N";
      this.record.HideProfitReports = this.HideProfitReports ? "Y" : "N";

      this.record.queryPercent = parseFloat(this.record.queryPercent) ?? 0.0;

      this.$store.commit("btnLoader", true);
      this.$emit("data", this.record);
    },
    getStores() {
      const self = this;
      this.$store
        .dispatch("get", `/stores`)
        .then(res => {
          if (res.ResultCode == 1200) {
            self.stores = res.ResponseData;
            // Update selected shops after stores are loaded
            self.updateSelectedShops();
          } else {
            this.$refs.snackbar.show(res.msg, "red");
          }
        })
        .catch(err => {
          this.$refs.snackbar.show(err, "red");
        });
    },
    getStoreSections() {
      const self = this;
      this.$store
        .dispatch("get", `/store-sections`)
        .then(res => {
          if (res.ResultCode == 1200) {
            self.storeSections = res.ResponseData;
          }
        })
        .catch(() => { });
    },
    getGroups() {
      const url = "/user-groups";
      const self = this;
      this.$store
        .dispatch("get", url)
        .then(res => {
          self.userGroups = res.ResponseData;
        })
        .catch(() => { });
    },
    saveShopSelection() {
      // Update selected shops array
      this.selectedShops = this.stores.filter(shop =>
        this.tempSelectedShopIds.includes(shop.id)
      );
      // Update record shopsAssigned
      this.record.shopsAssigned = this.tempSelectedShopIds;
      this.shopDialog = false;
    },
    removeShop(shopId) {
      this.selectedShops = this.selectedShops.filter(shop => shop.id !== shopId);
      this.record.shopsAssigned = this.record.shopsAssigned.filter(id => id !== shopId);
      this.tempSelectedShopIds = this.record.shopsAssigned;
    },
    updateSelectedShops() {
      if (this.record.shopsAssigned && this.record.shopsAssigned.length > 0) {
        this.selectedShops = this.stores.filter(shop =>
          this.record.shopsAssigned.includes(shop.id)
        );
        this.tempSelectedShopIds = [...this.record.shopsAssigned];
      }
    }
  },
  created() {
    this.getStores();
    this.getStoreSections();
    this.getGroups();
  }
};
</script>